import React from "react";

import styles from "./style.module.css";
import IMAGES from "aible/images";

function getIconImage(type) {
  return IMAGES[type];
}

function getBackgroundColor(type) {
  const COLORS = {
    green: "var(--green)",
    red: "var(--red)",
    grey: "var(--grey)",
    "light-grey": "var(--lightGrey)"
  };
  return COLORS[type] || type;
}

export default class Icon extends React.PureComponent {
  render() {
    const { className, style, type, alt, src, height, width, size, background, isRound, ...retProps } = this.props;
    let iconClass = styles.icon;
    if (className) {
      iconClass += " " + className;
    }
    const iconStyle = { ...style } || {};
    if (width !== undefined && !isNaN(width)) {
      iconStyle.width = width;
    }
    if (height !== undefined && !isNaN(height)) {
      iconStyle.height = height;
    }
    if (size !== undefined && !isNaN(size)) {
      iconStyle.width = size;
      iconStyle.height = size;
    }
    if (isRound) {
      iconStyle.borderRadius = "50%";
      if (iconStyle.padding === undefined) {
        iconStyle.padding = "4px";
      }
    }
    if (background) {
      iconStyle.background = getBackgroundColor(background);
    }

    const imgSrc = src || getIconImage(type);

    return (
      <div {...retProps} className={iconClass} style={iconStyle}>
        {imgSrc ? <img src={imgSrc} alt={alt || type || "icon"} /> : alt || type || ""}
      </div>
    );
  }
}
